import React from 'react'
import CookieBanner from 'react-cookie-banner'

const bannerStyles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: 'auto',
    background: 'rgba(31, 42, 55, 0.97)',
    padding: '16px 20px',
    boxSizing: 'border-box',
    textAlign: 'center',
    zIndex: 10000
  },
  message: {
    display: 'block',
    lineHeight: 1.5,
    fontWeight: 600,
    fontSize: '0.9rem',
    color: '#ffffff',
    margin: '0 0 12px 0'
  },
  link: {
    color: '#ffffff',
    textDecoration: 'underline',
    marginLeft: '6px'
  },
  button: {
    position: 'static',
    display: 'inline-block',
    top: 'auto',
    right: 'auto',
    marginTop: 0,
    background: '#e11d2a',
    color: '#ffffff',
    border: 'none',
    borderRadius: 0,
    padding: '9px 26px',
    fontSize: '0.95rem',
    fontWeight: 700,
    lineHeight: '1.2',
    cursor: 'pointer'
  }
}

const CookieBannerComponent = () => {
  return (
    <div>
      <CookieBanner
        styles={bannerStyles}
        message="Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso."
        onAccept={() => {}}
        cookie="user-has-accepted-cookies"
        buttonMessage="De acuerdo"
      />
    </div>
  )
}

export default CookieBannerComponent
